import type { ApolloErrorInterop } from '@confluence/apollo-relay-interop/entry-points/ApolloErrorInterop';

import { getApolloClient } from '@confluence/graphql/entry-points/getApolloClient';
import { markErrorAsHandled } from '@confluence/graphql/entry-points/markErrorAsHandled';
import { getMonitoringClient } from '@confluence/monitoring/entry-points/getMonitoringClient';
import { Attribution } from '@confluence/error-boundary/entry-points/Attribution';

import { LoomAuthTokenQuery } from './graphql/LoomAuthTokenQuery.graphql';
import type { LoomAuthTokenQuery as LoomAuthTokenQueryType } from './graphql/__types__/LoomAuthTokenQuery';
import { LoomAuthStateQuery } from './graphql/LoomAuthStateQuery.graphql';
import type {
	LoomUserStatus,
	LoomAuthStateQuery as LoomAuthStateQueryType,
} from './graphql/__types__/LoomAuthStateQuery';

type GetAuthTokenResponse = {
	recorderToken?: string;
	tokenError?: ApolloErrorInterop | Error | null;
};
export const getAuthToken = async (): Promise<GetAuthTokenResponse> => {
	try {
		// eslint-disable-next-line graphql-relay-compat/no-direct-apollo-query-and-mutation-operations -- Read http://go/cfe-no-direct-apollo-query-and-mutation-operations
		const tokenQuery = await getApolloClient().query<LoomAuthTokenQueryType>({
			query: LoomAuthTokenQuery,
			fetchPolicy: 'network-only',
		});
		return {
			recorderToken: tokenQuery.data.loomToken?.token,
		};
	} catch (e) {
		getMonitoringClient().submitError(e, {
			attribution: Attribution.CONTENT_TYPES,
		});
		markErrorAsHandled(e);
		return {
			tokenError: e,
		};
	}
};

export const getAuthState = async (): Promise<LoomUserStatus | undefined> => {
	try {
		// eslint-disable-next-line graphql-relay-compat/no-direct-apollo-query-and-mutation-operations -- Read http://go/cfe-no-direct-apollo-query-and-mutation-operations
		const authStateQuery = await getApolloClient().query<LoomAuthStateQueryType>({
			query: LoomAuthStateQuery,
		});

		return authStateQuery.data.loomUserStatus;
	} catch (e) {
		getMonitoringClient().submitError(e, {
			attribution: Attribution.CONTENT_TYPES,
		});
		markErrorAsHandled(e);
		return undefined;
	}
};
